import { render, staticRenderFns } from "./SellGoods.vue?vue&type=template&id=ca1c4b3e&scoped=true&"
import script from "./SellGoods.vue?vue&type=script&lang=js&"
export * from "./SellGoods.vue?vue&type=script&lang=js&"
import style0 from "./SellGoods.vue?vue&type=style&index=0&id=ca1c4b3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1c4b3e",
  null
  
)

export default component.exports